import React from 'react';
import Field from '../Field';
import AutoTextarea from '../AutoTextarea';

/**
 * qa: one question and its answer, rendered with schema.org FAQPage markup so
 * it is eligible for rich results. A run of consecutive qa sections is what
 * makes an FAQ block, so each pair is its own section -- use the section
 * controls around this form to add, remove and reorder pairs.
 */
export default function QaEditor({ idPrefix, data, onChange }) {
  const d = data || {};
  const set = (patch) => onChange({ ...d, ...patch });

  return (
    <>
      <Field id={`${idPrefix}-question`} label="Question" required hint="Written as a reader would ask it; this becomes the heading.">
        <AutoTextarea id={`${idPrefix}-question`} value={d.question || ''} onChange={(e) => set({ question: e.target.value })} placeholder="Is Zion free to enter?" minRows={2} />
      </Field>

      <Field id={`${idPrefix}-answer`} label="Answer" hint="Markdown. Answer in the first sentence, then add detail.">
        <AutoTextarea id={`${idPrefix}-answer`} value={d.answer || ''} onChange={(e) => set({ answer: e.target.value })} placeholder="No — $35 per vehicle, valid for seven days." minRows={4} />
      </Field>

      <Field id={`${idPrefix}-header_level`} label="Heading level" hint="h3 or h4 when the Q&A sits under another heading.">
        <select id={`${idPrefix}-header_level`} className="select" value={d.header_level || 'h2'} onChange={(e) => set({ header_level: e.target.value })}>
          <option value="h2">h2</option>
          <option value="h3">h3</option>
          <option value="h4">h4</option>
        </select>
      </Field>
    </>
  );
}
